import { render, staticRenderFns } from "./PercentageDiscountTable.vue?vue&type=template&id=aba28d66&scoped=true"
import script from "./PercentageDiscountTable.vue?vue&type=script&lang=js"
export * from "./PercentageDiscountTable.vue?vue&type=script&lang=js"
import style0 from "./PercentageDiscountTable.vue?vue&type=style&index=0&id=aba28d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba28d66",
  null
  
)

export default component.exports